function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoPaperticket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 29,
    viewBox: "0 0 43 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#757575",
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 2,
      fillOpacity: 1
    },
    d: "M 3.5625 1 C 2.1465 1 1 1.8646875 1 2.9296875 L 1 10.644531 C 3.819 10.644531 5.3652344 12.381906 5.3652344 14.503906 C 5.3652344 16.625906 3.819 18.359375 1 18.359375 L 1 26.070312 C 1 27.136312 2.1475 28 3.5625 28 L 39.4375 28 C 40.8525 28 42 27.135312 42 26.070312 L 42 18.361328 C 39.181 18.361328 37.634766 16.625906 37.634766 14.503906 C 37.634766 12.379906 39.181 10.644531 42 10.644531 L 42 2.9296875 C 42 1.8646875 40.8525 1 39.4375 1 L 3.5625 1 z M 12.691406 6 A 1.5 1.5 0 0 1 14.148438 7.5 A 1.5 1.5 0 0 1 11.148438 7.5 A 1.5 1.5 0 0 1 12.691406 6 z M 12.691406 13.5 A 1.5 1.5 0 0 1 14.148438 15 A 1.5 1.5 0 0 1 11.148438 15 A 1.5 1.5 0 0 1 12.691406 13.5 z M 12.457031 21 A 1.5 1.5 0 0 1 14 22.5 A 1.5 1.5 0 0 1 11 22.5 A 1.5 1.5 0 0 1 12.457031 21 z ",
    id: "path5493"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPaperticket);
export default __webpack_public_path__ + "static/media/ico-paperticket.d6253993.svg";
export { ForwardRef as ReactComponent };